

import XHeader from 'vux/src/components/x-header/index.vue'


const dataList = [{
src:"",
name:"设备管理",
tags:["PostgreSQL","Oracle","PostgreSQL","Oracle"],
discount:["2年8折","3年6折"],
money:"2000.00"
},{
src:"",
name:"设备管理",
tags:["PostgreSQL"],
discount:["2年8折"],
money:"2000.00"
},{
src:"",
name:"设备管理",
tags:["PostgreSQL","Oracle"],
discount:["2年8折","3年6折"],
money:"2000.00"
}]

export default {
components: {
XHeader
},
data () {
return {
showList:false,
dataList: dataList,
}
},
methods: {

},
mounted(){
var that = this;
document.addEventListener('click',function(e){
that.showList=false;
})
}
}



// WEBPACK FOOTER //
// ./src/views/saas/saasIndex.vue